export const wishLegacyPriorities = [
  'huge',
  'big',
  'small',
  'tiny',
  'none',
] as const

type WishLegacyPriority = typeof wishLegacyPriorities[number]
export default WishLegacyPriority
